import { httpsCallable } from 'firebase/functions';
import { functions } from './firebase';

const PROPOSE_CALLABLE_TIMEOUT_MS = 150_000;

export type OpportunityWeakPointPayload = {
  category: string;
  title: string;
  detail: string;
};

export type OpportunityFixProposal = {
  title: string;
  description: string;
  expectedImpact: string;
};

export type ProposeOpportunityFixesResponse = {
  proposals: OpportunityFixProposal[];
};

export function proposeOpportunityFixesErrorMessage(err: unknown): string {
  if (err && typeof err === 'object' && 'message' in err) {
    const message = String((err as { message: string }).message);
    if (message && !message.startsWith('Firebase')) {
      return message;
    }
  }
  if (err && typeof err === 'object' && 'code' in err) {
    const code = String((err as { code: string }).code);
    if (code === 'functions/unauthenticated') {
      return 'Sign in to get fix proposals.';
    }
    if (code === 'functions/unavailable') {
      return 'Proposal service is temporarily unavailable. Try again.';
    }
    if (code === 'functions/deadline-exceeded') {
      return 'Proposal generation timed out. Try again in a moment.';
    }
  }
  return err instanceof Error ? err.message : 'Could not generate fix proposals.';
}

export async function proposeOpportunityFixes(
  opportunityId: string,
  weakPoint: OpportunityWeakPointPayload
): Promise<ProposeOpportunityFixesResponse> {
  const fn = httpsCallable<
    { opportunityId: string; weakPoint: OpportunityWeakPointPayload },
    ProposeOpportunityFixesResponse
  >(functions, 'proposeOpportunityFixes', { timeout: PROPOSE_CALLABLE_TIMEOUT_MS });
  return (await fn({ opportunityId: opportunityId.trim(), weakPoint })).data;
}
